import { render, staticRenderFns } from "./DispatchCaregivers.vue?vue&type=template&id=bd587e02&scoped=true&"
import script from "./DispatchCaregivers.vue?vue&type=script&lang=js&"
export * from "./DispatchCaregivers.vue?vue&type=script&lang=js&"
import style0 from "./DispatchCaregivers.vue?vue&type=style&index=0&id=bd587e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd587e02",
  null
  
)

export default component.exports